import { SolidStatusPill } from '@odo/shared-ui';
import { humanizeManufacturerStatus } from './util';

// Manufacturer-reported case status pill (patient_monday_data.manufacturer_case_status).
// Rendering now lives in shared-ui's SolidStatusPill (solid box, white text,
// soft leading dot, colour hashed from the raw value). This wrapper only
// supplies the manufacturer-specific humanized label; the raw `status` still
// drives the colour hash so the hue is unaffected by display formatting.
export function ManufacturerStatusPill({ status }: { status: string }) {
    return <SolidStatusPill value={status} label={humanizeManufacturerStatus(status)} />;
}
